import React from "react";

/**
 * Выбор ролей пользователя: карточка на роль с названием и описанием.
 * `value` — массив id ролей. Стили — `.mg-role-*` из `pages/ManagementPages.css`
 * (компонент используется только внутри страниц «Управления»).
 */
export default function RoleCheckboxList({ roles, value, onChange, disabled = false }) {
  const selected = new Set(value);
  const toggle = (id) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    onChange([...next]);
  };

  if (!roles.length) return <span className="mg-muted">Ролей пока нет</span>;

  return (
    <div className="mg-role-list">
      {roles.map((r) => (
        <label key={r.id} className={`mg-role-option mg-toggle${selected.has(r.id) ? " mg-role-option--on" : ""}`}>
          <input type="checkbox" checked={selected.has(r.id)} disabled={disabled} onChange={() => toggle(r.id)} />
          <span>
            {r.label}
            {r.description && <span className="mg-role-desc">{r.description}</span>}
          </span>
        </label>
      ))}
    </div>
  );
}
